import keycloakService from '../../keycloak_service';

import { deleteRequestToKeycloak } from '../api_utils';

// This hook augments the passed in comments with their authoring users, fetching those users
// from Keycloak (via the Sinatra app) if necessary.
const removeUser = (userId = null) => {
  const keycloakHeader = keycloakService.getAuthHeader();
  const fetchOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakHeader,
    },
  };

  const realm = keycloakService.keycloak.realm || null;
  const keycloakEndpoint = `admin/realms/${realm}/users/${userId}`;

  return deleteRequestToKeycloak(keycloakEndpoint, fetchOptions);
};

export default removeUser;
